var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrap" },
    [
      _c("div", { staticClass: "title" }, [
        _c("div", { staticClass: "bar mr-5" }),
        _c("div", { staticClass: "text" }, [_vm._t("title")], 2),
        _c(
          "div",
          {
            class: ["packup", { "is-opened": _vm.isOpen }],
            on: { click: _vm.packup },
          },
          [
            _vm._v(_vm._s(_vm.isOpen ? "展开" : "收起")),
            _c("i", {
              staticClass: "el-submenu__icon-arrow el-icon-arrow-down bbqq",
            }),
          ]
        ),
      ]),
      _c("transition", { attrs: { name: "el-fade-in-linear" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isOpen,
                expression: "!isOpen",
              },
            ],
            staticClass: "main",
          },
          [_vm._t("default")],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }